import Cookies from "js-cookie";

const state = {
  sidebar: {
    opened: Cookies.get("sidebarStatus")
      ? !!Cookies.get("sidebarStatus")
      : true,
    withoutAnimation: false,
  },
  device: "desktop",
  labelPosition: "left",
  dialogFullscreen: false,
  powerStationParams: {}, // 设备管理查询参数暂存
};
const mutations = {
  alterDialogFullscreen: (state) => {
    state.dialogFullscreen = !state.dialogFullscreen;
  },
  TOGGLE_SIDEBAR: (state) => {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set("sidebarStatus", 1);
    } else {
      Cookies.set("sidebarStatus", 0);
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set("sidebarStatus", 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: (state, device) => {
    if (device === "mobile") {
      state.labelPosition = "top";
    } else {
      state.labelPosition = "left";
    }
    state.dialogFullscreen = device === "mobile";
    state.device = device;

    console.log("是否全屏？", state.dialogFullscreen, device);
  },
  setPowerStationParams(state, params) {
    state.powerStationParams = params;
  },
};

const actions = {
  Fullscreen({ commit }) {
    commit("alterDialogFullscreen");
  },
  toggleSideBar({ commit }) {
    commit("TOGGLE_SIDEBAR");
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit("CLOSE_SIDEBAR", withoutAnimation);
  },
  toggleDevice({ commit }, device) {
    commit("TOGGLE_DEVICE", device);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
